import { render, staticRenderFns } from "./UserDetailModal.vue?vue&type=template&id=f3186dd2&scoped=true&"
import script from "./UserDetailModal.vue?vue&type=script&lang=js&"
export * from "./UserDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3186dd2",
  null
  
)

export default component.exports